import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./invoicePackingEmailWindow.css";
import { filter } from "lodash";
import { toast } from "react-toastify";
import moment from "moment";
import {
	useTable,
	usePagination,
	useSortBy,
	useExpanded,
	useGlobalFilter,
	useRowSelect,
} from "react-table";
import { INVOICE_PACKING_EMAIL_COLUMNS } from "../components/columns/invoicePackingEmailColumns";
import { TableCheckbox } from "../components/common/tables/TableCheckbox";
import DailyPlanEmailStatus from "./dailyPlanEmailStatus";
import {
	getContainerMasterData,
	getContainerMasterDocs,
} from "../services/ContainerMasterService";
import { FormatDepartureReportDataForMail } from "../utils/dataFilter";
import InvoicePackagingPDFViewer from "../components/common/InvoicePackagingPDFViewer";
import { htmlEmailSendWithAttachment } from "../services/emailService";
import { InvPackingDocMailBody } from "./InvPackingDocMailBody";
import {
	invPackingRecepient,
	CC_invPackingRecepient,
} from "../services/emailService";
import store from "../store/Store";
import MainTablePaginationAdv from "../components/common/tables/MainTablePaginationAdv";
import noDataAvailable from "../assets/img/noDataAvailable.png";
import { dispatcher } from "../store/storeHelpers";
import * as actionTypes from "../store/ActionTypes";
import {
	emailStatusInvoicePackingTractor,
	emailStatusInvoicePackingAggregate,
	emailStatusInvoicePackingFiveM,
} from "../services/emailService";
import Counters from "../components/common/Counters";
import { PulseLoader } from "react-spinners";

function InvoicePackingEmailWindow({ type }) {
	const [emailBtn, setEmailBtn] = useState("Send Email");
	const [emailData, setEmailData] = useState([]);
	const [filteredSelectedFlatRow, setFilteredSelectedFlatRow] = useState([]);
	// const [columns] = useState([EMAIL_WINDOW_COLUMN])
	const [planDate, setPlanDate] = useState({
		fromdate: moment().format("YYYY-MM-DD"),
		todate: moment().format("YYYY-MM-DD"),
	});
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showViewModal, setShowViewModal] = useState(null);
	const [userData, setUserData] = useState([]);
	const [filteredUserAccessData, setFilteredUserAccessData] = useState([]);
	const [noDataState, setNoDataState] = useState(false);

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setUserData(Object.values(store.getState().userAccessData));
			setTableData(Object.values(store.getState().invoicePacking_email));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (
			filter(userData, { MenuName: "Invoice Packing Email", View: 1 }).length >
			0
		) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Invoice Packing Email", View: 1 })
			);
		}
	}, [userData]);

	var allowToSend = filter(filteredUserAccessData, { SendEmail: 1 }).length > 0;

	useEffect(() => {
		async function getData() {
			if (type === "InvoiceEmailWindow") {
				var filteredResponse = [];
				try {
					setLoading(true);
					setNoDataState(false);
					const response = await getContainerMasterData(planDate, "ContainerMaster");
					setLoading(false);
					for (let i = 0; i < response.data.length; i++) {
						if (response.data[i]["IsDocAvailable"] === 1) {
							filteredResponse.push(response.data[i]);
						}
					}
					if (filteredResponse.length === 0) {
						setNoDataState(true)
					}
					dispatcher(
						actionTypes.INVOICEPACKING_EMAIL_DATA,
						FormatDepartureReportDataForMail(filteredResponse)
					);
					setEmailData(filteredResponse);
					// setTableData(FormatDepartureReportDataForMail(filteredResponse));
				} catch (error) {
					setTableData([]);
					setLoading(false);
					if (error.response.data.StatusCode === 404) {
						setNoDataState(true);
					}
				}
			}
		}
		getData();
	}, [planDate, type]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		state,
		setPageSize,
		canPreviousPage,
		prepareRow,
		selectedFlatRows,
		setGlobalFilter,
	} = useTable(
		{
			columns: INVOICE_PACKING_EMAIL_COLUMNS,
			data: tableData,
			autoResetPage: false,
			initialState: { pageSize: 50 },
			autoResetExpanded: false,
			autoResetGlobalFilter: false,
		},
		useGlobalFilter,
		useSortBy,
		useExpanded,
		usePagination,
		useRowSelect,
		(hooks) => {
			hooks.visibleColumns.push((columns) => [
				{
					id: "selection",
					Header: ({ getToggleAllPageRowsSelectedProps }) => (
						<div>
							<TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
						</div>
					),
					Cell: ({ row }) => (
						<div>
							<TableCheckbox {...row.getToggleRowSelectedProps()} />
						</div>
					),
				},
				...columns,
			]);
		}
	);
	const { pageIndex, pageSize, globalFilter } = state;

	useEffect(() => {
		var planningId = [];
		for (let i = 0; i < selectedFlatRows.length; i++) {
			planningId.push(selectedFlatRows[i].original);
		}
		setFilteredSelectedFlatRow(planningId);
	}, [selectedFlatRows]);

	const cellRenderHandler = (cell) => {
		if (cell.column.id === "email_status") return "status";
		if (cell.column.id === "view_doc") return "view";
		else return "data";
	};

	const sendEmailHandler = async () => {
		setEmailBtn("Sending...");
		var containerIdArray = [];
		var docArray = [];
		let statusTractorIdList = "";
		let statusAggregateIdList = "";
		let statusFiveMIdList = "";
		let tractorArray = filter(filteredSelectedFlatRow, { DataOf: "TRACTOR" });
		let aggregateArray = filter(filteredSelectedFlatRow, {
			DataOf: "AGGREGATE",
		});
		let fiveMArray = filter(filteredSelectedFlatRow, { DataOf: "5M" });

		for (let i = 0; i < tractorArray.length; i++) {
			if (i !== tractorArray.length - 1) {
				statusTractorIdList += tractorArray[i]["ContainerMasterId"] + ",";
			} else {
				statusTractorIdList += tractorArray[i]["ContainerMasterId"];
			}
		}
		for (let i = 0; i < aggregateArray.length; i++) {
			if (i !== aggregateArray.length - 1) {
				statusAggregateIdList += aggregateArray[i]["ContainerMasterId"] + ",";
			} else {
				statusAggregateIdList += aggregateArray[i]["ContainerMasterId"];
			}
		}
		for (let i = 0; i < fiveMArray.length; i++) {
			if (i !== fiveMArray.length - 1) {
				statusFiveMIdList += fiveMArray[i]["ContainerMasterId"] + ",";
			} else {
				statusFiveMIdList += fiveMArray[i]["ContainerMasterId"];
			}
		}

		for (let i = 0; i < emailData.length; i++) {
			if (
				filter(filteredSelectedFlatRow, {
					ContainerMasterId: emailData[i]["ContainerMasterId"],
				}).length > 0
			) {
				containerIdArray.push(emailData[i].ContainerMasterId);
			}
		}
		for (let j = 0; j < containerIdArray.length; j++) {
			const datas = await getContainerMasterDocs(containerIdArray[j]);
			for (let k = 0; k < datas.data.length; k++) {
				docArray.push(datas.data[k]["InvoicePackingDoc"]);
			}
		}

		try {
			await htmlEmailSendWithAttachment({
				Mailto: invPackingRecepient,
				MailCc: CC_invPackingRecepient,
				strSubject: `Today's JD invoices & DNS under Self Sealing-${moment().format(
					"DD-MM-YYYY"
				)}`,
				body: InvPackingDocMailBody(),
				attachment: docArray,
				folderName : "ArbCommanFile"
			});
			setEmailBtn("Send Email");
			toast.success("Email sent successfully");

			if (statusTractorIdList !== "") {
				await emailStatusInvoicePackingTractor({
					ContainerMasterId: statusTractorIdList,
					isInvEmailSentTractor: 1,
				});
				dispatcher(actionTypes.UPDATE_INVOICEPACKING_EMAIL_DATA_TRACTOR, {
					data: filteredSelectedFlatRow,
					isInvEmailSentTractor: 1,
				});
			}
			if (statusAggregateIdList !== "") {
				await emailStatusInvoicePackingAggregate({
					ContainerMasterId: statusAggregateIdList,
					isInvEmailSentAggregate: 1,
				});
				dispatcher(actionTypes.UPDATE_INVOICEPACKING_EMAIL_DATA_AGGREGATE, {
					data: filteredSelectedFlatRow,
					isInvEmailSentAggregate: 1,
				});
			}
			if (statusFiveMIdList !== "") {
				await emailStatusInvoicePackingFiveM({
					ContainerMasterId: statusFiveMIdList,
					isInvEmailSent5M: 1,
				});
				dispatcher(actionTypes.UPDATE_INVOICEPACKING_EMAIL_DATA_5M, {
					data: filteredSelectedFlatRow,
					isInvEmailSent5M: 1,
				});
			}
		} catch (error) {
			setEmailBtn("Send Email");
			toast.error("Unable to send email...please try again.");
		}
	};

	function viewModalClickhandler(cell) {
		setShowViewModal(cell);
	}

	return (
		<>
			<div className="emailWindow__container">
				<div className="containerMasterEmailWindowCounterDiv">
					<Counters
						counter={{ Total: tableData.length !== 0 ? tableData.length : 0 }}
						label={["Total"]}
						styleData="df_dailyCounter absolute"
					/>
				</div>
				<div className="invPackingEmail__header__invPackingMail">
					<Form.Control
						value={globalFilter || ""}
						onChange={(e) => setGlobalFilter(e.target.value)}
						className="hiden-inp"
						placeholder="search here.."
						style={{ width: "30%", height: "36px" }}
					/>
					<div
						style={{
							display: "flex",
							width: "30%",
							alignItems: "center",
							marginLeft: "10px",
						}}
					>
						<strong>From-</strong>
						<Form.Control
							type="date"
							value={planDate.fromdate}
							onChange={(e) =>{
								if(e.target.value <= planDate.todate){
									setPlanDate({ ...planDate, fromdate: e.target.value })
								}else{
									setPlanDate({ ...planDate, fromdate: planDate.fromdate })
									alert('From date should not greater than To date.')
								}
							}}
							name="fromDate"
						/>
					</div>
					<div
						style={{
							display: "flex",
							width: "30%",
							alignItems: "center",
							marginLeft: "10px",
						}}
					>
						<strong>To-</strong>
						<Form.Control
							type="date"
							value={planDate.todate}
							onChange={(e) =>{
								if(e.target.value >= planDate.fromdate){
									setPlanDate({ ...planDate, todate: e.target.value })
								}else{
									setPlanDate({ ...planDate, todate: planDate.todate })
									alert('To date should not lesser than From date.')
								  }
							}}
							name="toDate"
						/>
					</div>
					<Button
						className="btn-primary btn-pill btn-sm mr4 sb sendInvPackingMailBtn"
						onClick={sendEmailHandler}
						style={{
							marginTop: "3px",
							marginLeft: "10px",
							marginRight: "20px",
						}}
						disabled={
							selectedFlatRows.length === 0 ||
							emailBtn === "Sending..." ||
							!allowToSend
						}
					>
						<i class="bx bxs-send"></i>
					</Button>
				</div>
				{/* <hr /> */}
				{loading && (
					<PulseLoader
						color="#007bff"
						size="20px"
						margin="10px"
						style={{ position: "absolute", top: "50vh", left: "45%" }}
					/>
				)}
				{noDataState && (
					<img
						src={noDataAvailable}
						alt="notAvailableImg"
						className="noDataFoundImg"
						// style={{ marginLeft: "-2%" }}
					/>
				)}
				{!noDataState && (
					<>
						<div className="table_container__invPackingMail">
							<table {...getTableProps()} className="table mtbs">
								<thead>
									{headerGroups.map((headerGroup) => (
										<tr {...headerGroup.getHeaderGroupProps()}>
											{headerGroup.headers.map((column) => (
												<th
													{...column.getHeaderProps(
														column.getSortByToggleProps()
													)}
												>
													{column.render("Header")}
													{column.id !== "selection" && (
														<i
															className={
																column.isSorted
																	? column.isSortedDesc
																		? "fi fi-rr-angle-small-down head-icon"
																		: "fi fi-rr-angle-small-up head-icon"
																	: "fi fi-rr-circle-small head-icon w"
															}
														></i>
													)}
												</th>
											))}
										</tr>
									))}
								</thead>
								<tbody {...getTableBodyProps()}>
									{page.map((row) => {
										prepareRow(row);
										return (
											<tr {...row.getRowProps()}>
												{row.cells.map((cell) => {
													return (
														<td
															{...cell.getCellProps()}
															className={
																cell.row.subRows.length !== 0
																	? "main-row"
																	: "sub-row"
															}
														>
															<div className="cell-wrap">
																{cellRenderHandler(cell) === "status" && (
																	<DailyPlanEmailStatus cell={cell} />
																)}
																{cellRenderHandler(cell) === "view" && (
																	<Button
																		className="btn btn-sm btn-tbl"
																		style={{
																			height: "35px",
																			marginRight: "50px",
																		}}
																		onClick={() => viewModalClickhandler(cell)}
																		// disabled={cell.row.original.Gate_Out_Date}
																	>
																		<i
																			class="bx bx-right-top-arrow-circle"
																			style={{ transform: "scale(2)" }}
																		></i>
																	</Button>
																)}
																{cell.column.id === "email_status" &&
																	(cell.row.original.isInvEmailSentTractor ===
																		1 ||
																		cell.row.original
																			.isInvEmailSentAggregate === 1 ||
																		cell.row.original.isInvEmailSent5M ===
																			1) && (
																		<button
																			style={{
																				display: "flex",
																				alignItems: "center",
																				background: "transparent",
																				border: "none",
																			}}
																		>
																			<i
																				class="bx bxs-badge-check"
																				style={{
																					color: "green",
																					background: "transparent",
																					transform: "scale(2)",
																					marginLeft: "-75px",
																				}}
																			></i>
																		</button>
																	)}
																{cellRenderHandler(cell) === "data" &&
																	cell.render("Cell")}
															</div>
														</td>
													);
												})}
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
						{/* <MainTablePagination
          nextPage={nextPage}
          previousPage={previousPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
          pageSize={pageSize}
          canPreviousPage={canPreviousPage}
          setPageSize={setPageSize}
        /> */}
						<MainTablePaginationAdv
							nextPage={nextPage}
							previousPage={previousPage}
							canNextPage={canNextPage}
							pageIndex={pageIndex}
							pageOptions={pageOptions}
							pageSize={pageSize}
							canPreviousPage={canPreviousPage}
							setPageSize={setPageSize}
							gotoPage={gotoPage}
							pageCount={pageCount}
						/>
					</>
				)}
				{showViewModal && (
					<InvoicePackagingPDFViewer
						show={showViewModal}
						hide={() => setShowViewModal(null)}
						date={planDate}
						type="mailScreen"
					/>
				)}
			</div>
		</>
	);
}
export default InvoicePackingEmailWindow;
